'use client';

import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabTypeformSnippet } from 'components/performance-lab/PerformanceLabTypeformSnippet';
import {
  buildPerformanceLabTypeformTracking,
} from 'lib/analytics/buildTypeformTrackingParams';
import {
  PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_ID,
  PERFORMANCE_LAB_CALLBACK_TYPEFORM_ID,
} from 'content/vo2MaxBannerConfig';
import { PerformanceLabModalBodyScrollLock } from './PerformanceLabModalBodyScrollLock';
import styles from './WaitlistTypeformModal.module.css';

type PerformanceLabTFModalProps = {
  flow?: string;
  typeformId?: string;
  /** @deprecated Use flow instead */
  planId?: string;
  /** @deprecated Use flow instead */
  source?: string;
};

export const PerformanceLabTFModal: React.FC<PerformanceLabTFModalProps> = ({
  flow,
  planId,
  source,
  typeformId = PERFORMANCE_LAB_BOOK_TOUR_TYPEFORM_ID,
}) => {
  const tCommon = useTranslations('common');

  const resolvedFlow =
    flow ||
    planId ||
    source ||
    (typeformId === PERFORMANCE_LAB_CALLBACK_TYPEFORM_ID
      ? 'pl_callback'
      : 'pl_book_tour');

  const trackingParams = useMemo(
    () => buildPerformanceLabTypeformTracking(resolvedFlow),
    [resolvedFlow],
  );

  return (
    <PerformanceLabModalBodyScrollLock>
      <div className={styles.modalRoot}>
        <div className={styles.typeformContainer}>
          <PerformanceLabTypeformSnippet
            typeformId={typeformId}
            frameTitle={tCommon('waitlistTypeformModal.typeformSnippet.frameTitle')}
            className="typeform-container"
            trackingParams={trackingParams}
          />
        </div>
      </div>
    </PerformanceLabModalBodyScrollLock>
  );
};
